function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M255.926,241.89L107.434,178.8L256.005,512l148.561-333.173L255.926,241.89z M166.152,236.49l89.766,38.139l89.952-38.164   l-89.866,201.538L166.152,236.49z"
}), React.createElement("path", {
  d: "M256.006,185.957c51.269,0,92.979-41.71,92.979-92.979S307.274,0,256.006,0s-92.979,41.71-92.979,92.979   S204.737,185.957,256.006,185.957z M256.006,30.135c34.652,0,62.844,28.192,62.844,62.844s-28.192,62.844-62.844,62.844   s-62.844-28.192-62.844-62.844S221.353,30.135,256.006,30.135z"
}));

var SvgMoveDown = function SvgMoveDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoveDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move-down.c9e8547b.svg";
export { ForwardRef as ReactComponent };